export enum BannerStyle {
    MobileContentAd = 'mobile-content-ad',
    MediumRect = 'medium-rectangle',
}

export enum Fold {
    Above = 'atf',
    Below = 'btf',
}

export enum BannerType {
    App = 'app',
    Web = 'web',
}

export enum Topic {
    Impression = 'as.odin.sda.impression',
    Initialized = 'as.odin.sda.initialized',
    Clicked = 'as.odin.sda.click',
}

export type SdaEvent = {
    slotIdentifier: string;
    rendered: boolean;
    articleNumber?: string;
};
